import React from 'react';
import BranchesComponent from '../components/Branches';
import Contact from '../components/Contact';
import './Branches.css';

function Branches() {
  return (
    <div className="branches-page">
      <BranchesComponent />
      <Contact />
    </div>
  );
}

export default Branches;
